import React from "react";
import { useRouteMatch } from "react-router-dom";

import { ShippingProfileList } from "./ShippingProfileList";
import { ShippingProfileDetail } from "./ShippingProfileDetail";
import { useShippingDetail } from "./ShippingProfileDetail/hooks";
import { ShippingZoneDetail } from "./ShippingZoneDetail";

function ShippingSettings() {
  const {
    params: { resourceId, zoneId }
  } = useRouteMatch();

  const shippingDetailProps = useShippingDetail(resourceId);
  if (resourceId && zoneId) {
    return (
      <ShippingZoneDetail
        profileId={resourceId}
        zoneId={zoneId}
        selectedStates={shippingDetailProps.selectedStates}
      />
    );
  } else if (resourceId) {
    return (
      <ShippingProfileDetail {...shippingDetailProps} profileId={resourceId} />
    );
  }

  return <ShippingProfileList />;
}

export default ShippingSettings;
